import React, { FC } from 'react'
import { connect, ConnectedProps } from 'react-redux';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { vesselActions, vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
	// isPrintVisible: boolean;
};
type ISealLogCoverPageProps = OwnProps & PropsFromRedux;

const SealLogCoverPage: FC<ISealLogCoverPageProps> = (props) => {
	const { vesselName, dateRange, pumps, hoses } = props;
	
	return (
		<div
			className='flex flex-col justify-between py-4 px-8 mb-2'
		>
			<div
				className='px-4'
			>
				<div
					style={{ marginTop: '10rem' }}
					className="font-medium text-center text-xl  mb-24"
				>
					<h3 className="uppercase">Overboard Seal Log</h3>
				</div>
				<div className="flex justify-center mt-8 mb-60">
					<div
						className='w-2/3 mt-2.5'
					>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Name of ship:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
								{vesselName}
							</p>
						</div>

						<div
							className="flex justify-between items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<div
								style={{ width: '54%' }}
								className="flex items-center  mb-2"
							>
								<p className="mr-2 min-w-fit">Period from :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
									{dateRange?.startDate &&
										moment(dateRange?.startDate).format(
											'DD-MM-yyyy'
										)}{' '}
								</p>
							</div>
							<div
								style={{ width: '45%' }}
								className="flex items-center  mb-2"
							>
								<p className="mr-2 min-w-fit">to :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
									{dateRange?.endDate &&
										moment(dateRange?.endDate).format(
											'DD-MM-yyyy'
										)}
								</p>
							</div>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
								English
							</p>
						</div>
					</div>
				</div>
			</div>

			<div
				className="newpage flex flex-col justify-between py-0 pt-4 px-8 mb-2 text-justify"
			>
				<p className="py-2">
					1. All engine room ship's side overboard valves are to be listed under 'Location'. This is to include all suction, discharge and storm valves.
				</p>
				<p className="py-2">
					2. All sections of the bilge overboard line from the Bilge Water Separator to the overboard valve are to be listed under 'Location'.
				</p>
				<p className="py-2">
					3. The covers on the soot collecting tank are to be listed under 'Location'.
				</p>
				<p className="py-2">
					4. The seal numbers of all sea water suction, overboard and storm valves are to be recorded with the date and time of fitting together with the seal numbers from each section of the bilge water overboard line.
				</p>
				<p className="py-2">
					5. The 'Remarks' column is to be completed on each occasion that a seal is removed. Full details of the reason for seal removal are to be recorded.
				</p>
				<p className="py-2">
					6. The date and time of removing seals is to be recorded.
				</p>
				<p className="py-2">
					7. A new entry is to be made when a seal is refitted to any system.
				</p>
				<p className="py-2">
					8. Each entry is to be initialed by the Chief Engineer.
				</p>
			</div>
			<div
				className=''
			>
				<div className="w-full newpage">
					<div
						style={{ marginTop: '10rem' }}
						className="font-medium text-center text-xl mb-4"
					>
						<h3 className="uppercase">Pumps</h3>
					</div>
					<table className="w-full wayship-table">
						<thead>
							<tr className="theader">
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap min-w-[100px]">
										Id Number
									</div>
								</th>
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
										Type
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{pumps?.map((pump, index) => {
								const {
									id_number,
									type,
								} = pump;

								return (
									<React.Fragment key={id_number + index}>
										<tr>
											<td className="md:text-xs xl:text-sm">
												{id_number}
											</td>
											<td className="md:text-xs xl:text-sm">
												{type}
											</td>
										</tr>
									</React.Fragment>
								);
							})}
						</tbody>
					</table>
				</div>
				<div className="w-full mt-8">
					<div
						style={{ marginTop: '10rem' }}
						className="font-medium text-center text-xl mb-4"
					>
						<h3 className="uppercase">Hoses</h3>
					</div>
					<table className="w-full wayship-table">
						<thead>
							<tr className="theader">
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap min-w-[100px]">
										Id Number
									</div>
								</th>
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
										Diameter
									</div>
								</th>
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
										Length
									</div>
								</th>
								<th>
									<div className="p-2 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 border-gray-300 whitespace-nowrap min-w-20">
										Material
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{hoses?.map((hose, index) => {
								const {
									id_number,
									diameter,
									length,
									material,
								} = hose;

								return (
									<React.Fragment key={id_number + index}>
										<tr>
											<td className="md:text-xs xl:text-sm">
												{id_number}
											</td>
											<td className="md:text-xs xl:text-sm">
												{diameter}
											</td>
											<td className="md:text-xs xl:text-sm">
												{length}
											</td>
											<td className="md:text-xs xl:text-sm">
												{material}
											</td>
										</tr>
									</React.Fragment>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	const pumps = vesselSelectors.getPortablePumps(vesselStore);
	const hoses = vesselSelectors.getFlexibleHoses(vesselStore);

	return {
		vesselName: vesselInfo.vesselName,
		dateRange,
		pumps,
		hoses,
	};
}

const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(SealLogCoverPage);
